import { fetch_sadap } from "../../core/api"

export const WorkUnitGet= (params)=>{
    let arr_param=[]
    for(let i in params){
        arr_param.push(`${i}=${params[i]}`)
    }
    let data = arr_param.length>0?`?${arr_param.join("&")}`:""
    let path = `employee-biodata/workunit/list${data}`
    return fetch_sadap(path,"get",{},false)
}